export const extractAllergenClassName = (fontAwesomeHtmlElement: String | null) => {
  if (!fontAwesomeHtmlElement) {
    return '';
  }

  const className = fontAwesomeHtmlElement.replace('<i class="fak fa-', '').replace('"></i>', '');

  if (className) {
    return className;
  }

  return '';
};
